import { gql } from '@apollo/client';

export const REQUEST_TOKEN_MUTATION = gql(`
  mutation RequestToken($email: String!, $password: String!, $clientType: String!) {
    tokenAuth(email: $email, password: $password, clientType: $clientType) {
      token,
      refreshToken,
      user {
        uid,
        emailVerified,
        firstName,
        language
      }
    }
  }
`);

export const REFRESH_TOKEN_MUTATION = gql(`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      token,
      refreshToken
    }
  }
`);

export const RESET_PASSWORD = gql(`
  mutation ResetPassword($email: String!) {
      resetPassword(email: $email) {
          success
      }
  }
  `);

export const UPDATE_PASSWORD = gql(`
  mutation UpdatePassword($userUid: String!, $newPassword: String!, $token: String!) {
      updatePassword(userUid: $userUid, newPassword: $newPassword, token: $token) {
          redirectUrl
      }
  }
`);

export const REPORT_PARTICIPANT_ASSESSMENT_RESULT_MUTATION = gql(`
    mutation ReportParticipant(
      $pdtUid: String!,
      $assessmentUid: String!,
      $assessmentAnswers: [String]!,
      $assignmentUid: String!,
      $assignmentCompleteTime: DateTime,
    ) {
        reportParticipantAssessmentResult(
            pdtUid: $pdtUid,
            assessmentUid: $assessmentUid,
            assessmentAnswers: $assessmentAnswers,
            assignmentUid: $assignmentUid,
            assignmentCompleteTime: $assignmentCompleteTime,
        ) {
            participantAssessmentResult {
                uid
            }
        }
    }
`);

export const RESEND_VERIFICATION_EMAIL = gql(`
  mutation ResendVerificationEmail($email: String!) {
    resendEmailVerification(email: $email) {
      success
    }
  }
`);

export const SEND_EMAIL_CHANGE_VERIFICATION = gql(`
  mutation SendEmailChangeVerification(
    $previousEmail: String!
    $email: String!
    $pdtUid: String!
    $token: String!
  ) {
    sendEmailChangeVerification(
      previousEmail: $previousEmail
      email: $email
      pdtUid: $pdtUid
      token: $token
    ) {
      success
    }
  }
`);

export const ENROLL_PATIENT = gql(`
  mutation enrollDirectAccessPatient(
    $email: String!,
    $phone: String,
    $firstName: String!,
    $lastName: String!,
    $dateOfBirth: DateTime,
    $pdtUid: String!,
    $organizationSlug: String!,
    $address: String,
    $state: String,
    $city: String,
    $postalCode: String,
    $emergencyContactName: String,
    $emergencyContactEmail: String,
    $emergencyContactPhone: String,
    $uid: String,
    $safetyAcknowledgedAt: String,
    $termsAndPrivacyAcknowledgedAt: String,
    $language: String,
    $utmSource: String,
    $utmMedium: String,
    $utmCampaign: String,
    $utmTerm: String,
    $utmContent: String,
    $utmId: String,
    $utmCampaignDate: String,
    $isDependent: Boolean,
    $externalId: String,
    $password: String,
  ) {
    enrollDirectAccessPatient(
      email: $email,
      phone: $phone,
      firstName: $firstName,
      lastName: $lastName,
      dateOfBirth: $dateOfBirth,
      pdtUid: $pdtUid,
      organizationSlug: $organizationSlug,
      address: $address,
      state: $state,
      city: $city,
      postalCode: $postalCode,
      emergencyContactName: $emergencyContactName,
      emergencyContactEmail: $emergencyContactEmail,
      emergencyContactPhone: $emergencyContactPhone,
      uid: $uid,
      safetyAcknowledgedAt: $safetyAcknowledgedAt,
      termsAndPrivacyAcknowledgedAt: $termsAndPrivacyAcknowledgedAt,
      language: $language,
      utmSource: $utmSource,
      utmMedium: $utmMedium,
      utmCampaign: $utmCampaign,
      utmTerm: $utmTerm,
      utmContent: $utmContent,
      utmId: $utmId,
      utmCampaignDate: $utmCampaignDate,
      isDependent: $isDependent,
      externalId: $externalId,
      password: $password,
    ) {
      success
      patientUid
      userUid
    }
  }

`);

export const ENROLL_PATIENT_PLATGEN = gql(`
  mutation enrollPatientPlatgen(
    $email: String!
    $firstName: String!
    $lastName: String!
    $password: String!
    $pdtUid: String!
    $externalId: String
    $organizationSlug: String!
    $termsAndPrivacyAcknowledgedAt: String!
    $phone: String
    $posthogDistinctId: String
  ) {
    enrollPatientPlatgen(
      email: $email
      firstName: $firstName
      lastName: $lastName
      password: $password
      pdtUid: $pdtUid
      externalId: $externalId
      organizationSlug: $organizationSlug
      termsAndPrivacyAcknowledgedAt: $termsAndPrivacyAcknowledgedAt
      phone: $phone
      posthogDistinctId: $posthogDistinctId
    ) {
      success
      patientUid
      userUid
      platgenId
    }
  }
`);

export const ENROLL_DIRECT_ACCESS_PATIENT_V2 = gql(`
  mutation enrollDirectAccessPatientV2(
    $email: String!
    $language: String
    $organizationSlug: String!
    $pdtUid: String!
    $termsAndPrivacyAcknowledgedAt: String!
    $posthogDistinctId: String
    $phone: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $utmId: String
    $utmCampaignDate: String
    $isDependent: Boolean
    $marketingSmsConsent: Boolean
  ) {
    enrollDirectAccessPatientV2(
      email: $email
      language: $language
      organizationSlug: $organizationSlug
      pdtUid: $pdtUid
      termsAndPrivacyAcknowledgedAt: $termsAndPrivacyAcknowledgedAt
      posthogDistinctId: $posthogDistinctId
      phone: $phone
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
      utmId: $utmId
      utmCampaignDate: $utmCampaignDate
      isDependent: $isDependent
      marketingSmsConsent: $marketingSmsConsent
    ) {
      success
      patientUid
      userUid
    }
  }
`);

export const ENROLL_COVERED_EMPLOYEE_PATIENT = gql(`
  mutation enrollCoveredEmployeePatient(
    $email: String!
    $firstName: String!
    $lastName: String!
    $dateOfBirth: Date!
    $organizationSlug: String!
    $pdtUid: String!
    $termsAndPrivacyAcknowledgedAt: String!
    $posthogDistinctId: String!
    $postalCode: String
    $employeeId: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $utmId: String
    $utmCampaignDate: String
  ) {
    enrollCoveredEmployeePatient(
      email: $email
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
      organizationSlug: $organizationSlug
      pdtUid: $pdtUid
      termsAndPrivacyAcknowledgedAt: $termsAndPrivacyAcknowledgedAt
      posthogDistinctId: $posthogDistinctId
      postalCode: $postalCode
      employeeId: $employeeId
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
      utmId: $utmId
      utmCampaignDate: $utmCampaignDate
    ) {
      success
      eligible
      existingUser
      careTeamUid
      token
      distinctId
      cortexId
    }
  }
`);

export const SET_EMAIL_VERIFIED = gql(`
  mutation SetEmailVerified(
    $careTeamUid: String!
    $token: String!
  ) {
    setEmailVerified(careTeamUid: $careTeamUid, token: $token) {
      success
      userUid
      distinctId
    }
  }
`);

export const SAVE_SLEEPIO_COVERAGE_DETAILS = gql(`
  mutation SaveCoverageDetails(
    $careTeamUid: String!
    $token: String!
    $dateOfBirth: Date!,
    $firstName: String!,
    $lastName: String!,
    $postalCode: String,
    $coverageCheckTimestamp: DateTime!,
    $coverageCheckStartTimestamp: DateTime,
    $coverageCheckStatus: String!,
    $employeeId: String,
  ) {
    saveCoverageDetails(
      careTeamUid: $careTeamUid,
      token: $token,
      dateOfBirth: $dateOfBirth,
      firstName: $firstName,
      lastName: $lastName,
      postalCode: $postalCode,
      coverageCheckTimestamp: $coverageCheckTimestamp,
      coverageCheckStartTimestamp: $coverageCheckStartTimestamp,
      coverageCheckStatus: $coverageCheckStatus,
      employeeId: $employeeId,
    ) {
      success
      email
      userUid
    }
  }
`);

export const CONSUMER_APP_SAVE_COVERAGE_DETAILS = gql(`
  mutation ConsumerAppSaveCoverageDetails(
    $pdtUid: String!
    $firstName: String!
    $lastName: String!
    $dateOfBirth: Date!
    $coverageCheckTimestamp: DateTime!
    $coverageCheckStatus: String!
    $postalCode: String
    $employeeId: String
    $coverageCheckStartTimestamp: DateTime
  ) {
    consumerAppSaveCoverageDetails(
      pdtUid: $pdtUid
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
      coverageCheckTimestamp: $coverageCheckTimestamp
      coverageCheckStatus: $coverageCheckStatus
      postalCode: $postalCode
      employeeId: $employeeId
      coverageCheckStartTimestamp: $coverageCheckStartTimestamp
    ) {
      success
    }
  }
`);

export const GET_AUTH_METHODS_FOR_ACCESS_CODE = gql(`
  mutation GetAuthMethodsForAccessCode($accessCode: String!, $pdtUid: String!) {
    getAuthMethodsForAccessCode(accessCode: $accessCode, pdtUid: $pdtUid) {
      authMethods
    }
  }
`);

export const ACTIVATE_PATIENT = gql(`
  mutation ActivatePatient($pdtUid: String!, $organizationSlug: String!) {
    activatePatient(pdtUid: $pdtUid, organizationSlug: $organizationSlug) {
      success
    }
  }
`);

export const SAVE_PASSWORD_AND_ACTIVATE_USER = gql(`
  mutation savePasswordAndActivateUser(
    $careTeamUid: String!
    $password: String!
    $token: String!
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $utmId: String
    $utmCampaignDate: String
    $clientType: String 
  ) {
    savePasswordAndActivateUser(
      careTeamUid: $careTeamUid
      password: $password
      token: $token
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
      utmId: $utmId
      utmCampaignDate: $utmCampaignDate
      clientType: $clientType
    ) {
      success
      authToken {
        token
        refreshToken
        user {
          uid
          email
        }
      }
    }
  }
`);

export const SAVE_PASSWORD_AND_ACTIVATE_SOLERA_USER = gql(`
  mutation savePasswordAndActivateSoleraUser(
    $careTeamUid: String!
    $password: String!
    $phone: String!
    $token: String!
    $clientType: String 
  ) {
    savePasswordAndActivateSoleraUser(
      careTeamUid: $careTeamUid
      password: $password
      phone: $phone
      token: $token
      clientType: $clientType
    ) {
      success
      authToken {
        token
        refreshToken
        user {
          uid
          email
        }
      }
    }
  }
`);

export const SEND_READY_TO_DOWNLOAD_SMS = gql(`
  mutation sendReadyToDownloadSms(
    $careTeamUid: String!
    $phoneNumber: String
    $textConsentAcknowledgedAt: String
    $marketingSmsConsent: Boolean
  ) {
    sendReadyToDownloadSms(
      careTeamUid: $careTeamUid
      phoneNumber: $phoneNumber
      textConsentAcknowledgedAt: $textConsentAcknowledgedAt
      marketingSmsConsent: $marketingSmsConsent
    ) {
      success
    }
  }
`);

export const ENROLL_SOLERA_PATIENT = gql(`
  mutation enrollSoleraPatient(
    $enrollmentId: String!
    $pdtUid: String!
    $organizationSlug: String!
  ) {
    enrollSoleraPatient(
      enrollmentId: $enrollmentId
      pdtUid: $pdtUid
      organizationSlug: $organizationSlug
    ) {
      success
      careTeamUid
      token
      patient {
        uid
        user {
          uid
          email
          firstName
          lastName
          phone
        }
        location {
          city
          state
          postalCode
        }
      }
    }
  }
`);

export const VERIFY_ACCESS_CODE = gql(`
  mutation verifyAccessCode(
    $accessCode: String!
    $pdtUid: String!
    $isStudyCode: Boolean
  ) {
    verifyAccessCode(
      accessCode: $accessCode
      pdtUid: $pdtUid
      isStudyCode: $isStudyCode
    ) {
      valid
    }
  }
`);

export const ACTIVATE_USER_BY_ACCESS_CODE = gql(`
  mutation activateUserByAccessCode($accessCode: String!) {
    activateUserByAccessCode(accessCode: $accessCode) {
      success
    }
  }
`);

export const EDIT_PATIENT_INFO = gql(`
  mutation editPatientInfo(
    $changeReason: String!
    $firstName: String
    $lastName: String
    $dateOfBirth: DateTime
    $phone: String
  ) {
    editPatientInfo(
      changeReason: $changeReason
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
      phone: $phone
    ) {
      success
    }
  }
`);
